import { defineComponent as _defineComponent } from 'vue'
import UserIconMenu from '@/app/components/user/UserIconMenu.vue';
import UpdatesModal from '@/app/components/updates/UpdatesModal.vue';
import SideNavMobile from './SideNavMobile.vue';
import NeedHelpButton from '../common/NeedHelpButton.vue';
import { XHedgeEventBusEvents } from '@/app/constants/events';
import { FileExportsModal } from 'ah-notifications';
import { useNotificationsStore } from 'ah-notifications/src/store';
import { computed, ref } from 'vue';
import { useEventBusListener } from 'ah-common-lib/src/eventBus/EventBusPlugin';
import XHedgeNotificationsModal from './XHedgeNotificationsModal.vue';
import ReferralButton from '../common/ReferralButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PrivateTopNav',
  setup(__props) {

const updatesModal = ref<InstanceType<typeof UpdatesModal>>();

const notificationsStore = useNotificationsStore();

function showUpdates() {
  updatesModal.value?.show();
}

useEventBusListener(XHedgeEventBusEvents.SHOW_UPDATES, showUpdates);

const hasUnreadFileExports = computed(() => notificationsStore.fileExportUnreadCount > 0);

const hasUnreadUpdates = computed(() => notificationsStore.updateUnreadCount > 0);

return { __sfc: true,updatesModal, notificationsStore, showUpdates, hasUnreadFileExports, hasUnreadUpdates, UserIconMenu, UpdatesModal, SideNavMobile, NeedHelpButton, FileExportsModal, XHedgeNotificationsModal, ReferralButton }
}

})